<template>
    <div>
        <div class="flex justify-end">
            <button
                type="button"
                class="btn btn-md is-ghost"
                @click="$modal.show('update-order-address')"
            >
                Flytta order
            </button>
        </div>

        <adaptive-modal
            name="update-order-address"
            primary-button-text="Flytta order"
            title="Flytta order"
            method="delete"
            :hide-action-buttons="true"
        >
            <p>Välj adress dit ordern skall flyttas. Sök genom att trycka på Enter.</p>

            <div class="w-full mt-md">
                <div class="form-group form-input-with-icon">
                    <font-awesome-icon
                        icon="search"
                        class="text-xs"
                    />
                    <input
                        v-model="query"
                        type="text"
                        class="form-input"
                        style="height: 56px;"
                        placeholder="Sök på adress (minst tre tecken)"
                        @keydown.enter="searchAddresses"
                    >
                    <div v-if="loading" class="absolute pin-r text-center mr-4xl pin-t mt-lg">
                        <font-awesome-icon
                            class="text-md mt-xs"
                            icon="spinner"
                            spin
                            pulse
                        />
                    </div>
                </div>
            </div>

            <div
                v-if="error"
                class="w-full mt-md text-danger"
            >
                {{ error }}
            </div>

            <div
                v-if="noResults"
                class="w-full mt-md text-danger"
            >
                <em>Inga resultat kunde hittas.</em>
            </div>

            <div
                v-if="addresses.length"
                class="overflow-auto"
                style="max-height: 400px;"
            >
                <table class="table">
                    <thead>
                        <tr>
                            <th>Adress</th>
                            <th>Säljprojekt</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="address in addresses"
                            :key="address.id"
                        >
                            <td>
                                <radio-input
                                    v-model="selectedAddressId"
                                    class="mb-md"
                                    :value="address.id"
                                >
                                    {{ address.full_address_with_apartment_number }}
                                </radio-input>
                            </td>
                            <td>
                                {{ address.sales_project_name }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="flex justify-between mt-2xl flex-row">
                <button
                    type="button"
                    class="btn is-ghost btn-big"
                    @click="$modal.hide('update-order-address')"
                >
                    Avbryt
                </button>
                <slot name="primary-action">
                    <button
                        :disabled="! selectedAddressId || loading || saving"
                        type="button"
                        class="btn btn-big is-primary"
                        @click="save"
                    >
                        Flytta order

                        <font-awesome-icon
                            v-if="saving"
                            class="ml-md"
                            icon="spinner"
                            spin
                        />
                    </button>
                </slot>
            </div>
        </adaptive-modal>
    </div>
</template>

<script>
    export default {
        props: {
            order: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                query: '',
                error: '',
                loading: false,
                saving: false,
                hasSearched: false,
                addresses: [],
                selectedAddressId: 0,
            };
        },
        computed: {
            noResults() {
                return this.query && ! this.loading && ! this.addresses.length && this.hasSearched;
            },
        },
        methods: {
            searchAddresses() {
                const query = this.query;
                if (! query) {
                    return;
                }

                this.addresses = [];
                this.loading = true;
                this.hasSearched = true;
                this.selectedAddressId = 0;

                axios.get(route('api.transfer-order.index'), { params: { query } })
                    .then(({ data }) => {
                        this.addresses = data;
                        this.loading = false;
                    }).catch((error) => {
                        this.loading = false;

                        if (error.response.data.message) {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Något gick tyvärr fel.';
                        }
                    });
            },
            async save() {
                this.saving = true;

                await axios.patch(route('api.transfer-order.update', [this.order, this.selectedAddressId]))
                    .catch((error) => {
                        this.saving = false;

                        if (error.response.data.message) {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Något gick tyvärr fel.';
                        }
                    });

                window.location = window.location.href;
            },
        },
    };
</script>
